import React from "react";
import {Box, Heading, Form, FormField, Button, CheckBox,Layer as LayerGrommet} from "grommet";
import {QUERY_PACKAGE_LIST, QUERY_SINGLE_USER_PACKAGE, UPSERT_USER_PACKAGE} from "./UserGQL.js";
import {FormClose} from "grommet-icons";
import { useLazyQuery,useMutation } from '@apollo/client';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {extractIdFormData} from "../../../utilis/utils";
import moment from "moment";
import {PropaneSharp} from "@mui/icons-material";
import {QUERY_SERVICE_AREA_LIST} from "../clubmateService/ServiceGQL.js";
export default function LayerChangeEntranceNumber(props) {

    const [formData,setFormData]=React.useState( {});
    const [mutationChangeEntranceNumber]=useMutation(UPSERT_USER_PACKAGE);
    const [newEntranceNumber,setNewEntranceNumber]=React.useState(0);
    const [ queryGetUserPackage
    ]  = useLazyQuery(QUERY_SINGLE_USER_PACKAGE, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log("data",data);
            if(data["clubmate_usersregister_userpackage_by_pk"]){
                setFormData(data["clubmate_usersregister_userpackage_by_pk"]);
            }
        },
        onError:(error)=>{
            console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });

    React.useEffect(() =>{
       queryGetUserPackage({variables: {id:props?.formData?.id}});
    },[])

    function onUpsertPackUser() {
        let formDataApp={...formData}
        let obj={variables:{input:{package:null,user:null,numberOfEntry:null}}};
        console.log("FORMDATA",formData);
        obj["variables"]["input"]["package"] = formDataApp["package_id"];
        obj["variables"]["input"]["user"] = formDataApp["user_id"];
        obj["variables"]["input"]["numberOfEntry"] = newEntranceNumber
        obj["variables"]["input"]["id"] = props?.formData?.id
        console.log("OBJ",obj)
        mutationChangeEntranceNumber(obj)
            .then((value) => {
                //setFormData(value.data[`${tenant}`][`upsertUser${tenantTypeFirstUpperCase}`])
                alert("Ingressi aggiornati correttamente");
                if (props?.reloadQuery) {
                    props?.reloadQuery()
                }
                onEscLayer();
            }).catch((value) => {
            console.error(value);
            alert("Errore durante l'operazione");
        })
    }

    function onEscLayer(){
        if(props.onEscLayer){
            props.onEscLayer();
        }
        setFormData({});
    }


    return (
        <LayerGrommet style={{height: "60%", width: '40%'}} onEscLayer={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
            <Box height="100%" round pad="medium" direction="column" background="#ffffff" align="center" overflow="auto">
                <Button alignSelf="end" icon={<FormClose color="grey" size="35px" onClick={onEscLayer}/>}></Button>
                <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
                    <Box direction="row" gap="large">
                        {"Inserisci nuovo numero ingressi"}
                        {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Personale.csv"} style={{width:'200px',fontSize:'20px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button>  */}
                    </Box>
                </Heading>
                <Box align="center" gap="small">
                    <Form style={{marginTop:"50px"}}>
                        <TextField
                            label="Ingressi"
                            onChange={(e)=>setNewEntranceNumber(parseInt(e.target.value))}
                        ></TextField>
                    </Form>
                    <Box direction="row" gap="medium" alignSelf="center" style={{marginTop:30+"px"}}>
                        <Button label={"Aggiorna"} onClick={()=>onUpsertPackUser()} style={{width:'170px',height:'34px',fontSize:'18px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
                    </Box>
                </Box>

            </Box>
        </LayerGrommet>
    )
}